import React, { useState, useMemo } from "react";
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material";
import { tryFormatMoney } from "../../../Helpers";

interface IC190DetailsDataProps {
  c190: any[];
}

const C190DetailsData: React.FC<IC190DetailsDataProps> = ({ c190 = [] }) => {
  const [selectedRow, setSelectedRow] = useState<number | null>(null);

  const headers = useMemo(() => [
    { id: "cst_icms", label: "CST ICMS" },
    { id: "cfop", label: "CFOP" },
    { id: "aliq_icms", label: "ALÍQUOTA DO ICMS" },
    { id: "vl_opr", label: "VALOR DA OPERAÇÃO", isMoney: true },
    { id: "vl_bc_icms", label: "VALOR BC ICMS", isMoney: true },
    { id: "vl_icms", label: "VALOR DO ICMS", isMoney: true },
    { id: "vl_bc_icms_st", label: "VALOR BC ICMS ST", isMoney: true },
    { id: "vl_icms_st", label: "VALOR DO ICMS ST", isMoney: true },
    { id: "vl_red_bc", label: "VALOR DE REDUÇÃO BC", isMoney: true },
    { id: "vl_ipi", label: "VALOR DO IPI", isMoney: true },
    { id: "cod_obs", label: "COD OBS" }
  ], []);

  if (!c190.length) return null;

  return (
    <Grid item xs={12}>
      <Typography
        variant="h6"
        sx={{
          textTransform: "uppercase",
          color: "rgb(148 148 148)",
          my: 4
        }}
      >
        Totais
      </Typography>

      <TableContainer
        component={Paper}
        sx={{ 
          maxHeight: 400,
          overflowX: 'auto',
          overflowY: 'auto'
        }}
        aria-label="Tabela de totais C190"
      >
        <Table stickyHeader size="small" sx={{ minWidth: 800 }}>
          <TableHead>
            <TableRow>
              <TableCell align="center" sx={{ width: '50px', color: "rgb(148 148 148)", fontWeight: 'bold' }}>
                #
              </TableCell>
              {headers.map(({ id, label, isMoney }) => (
                <TableCell
                  key={id}
                  sx={{ 
                    color: "rgb(148 148 148)", 
                    whiteSpace: "nowrap",
                    fontWeight: 'bold',
                    minWidth: isMoney ? '120px' : '100px'
                  }}
                >
                  {label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {c190.map((item, index) => (
              <TableRow
                key={index}
                hover
                onClick={() => setSelectedRow(index)}
                sx={{
                  cursor: "pointer",
                  backgroundColor: selectedRow === index ? "#f5f5f5" : "inherit"
                }}
              >
                <TableCell 
                  align="center" 
                  sx={{ 
                    width: '50px',
                    fontWeight: 500,
                    color: 'text.secondary'
                  }}
                >
                  {index + 1}
                </TableCell>
                {headers.map(({ id, isMoney }) => (
                  <TableCell
                    key={id}
                    sx={{ 
                      textAlign: isMoney ? "right" : "left",
                      whiteSpace: "nowrap"
                    }}
                  >
                    {isMoney
                      ? tryFormatMoney(item[id])
                      : item[id] ?? ""}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
};

export default C190DetailsData;
